"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpecialtyNotificationScope = void 0;
exports.instanceOfSpecialtyNotificationScope = instanceOfSpecialtyNotificationScope;
exports.SpecialtyNotificationScopeFromJSON = SpecialtyNotificationScopeFromJSON;
exports.SpecialtyNotificationScopeFromJSONTyped = SpecialtyNotificationScopeFromJSONTyped;
exports.SpecialtyNotificationScopeToJSON = SpecialtyNotificationScopeToJSON;
exports.SpecialtyNotificationScopeToJSONTyped = SpecialtyNotificationScopeToJSONTyped;
/**
 * How widely the member wants to be notified at this facility. Members who have never chosen are ALL. SOME with no specialtyCodes means the member wants no specialty-based notifications.
 * @export
 */
exports.SpecialtyNotificationScope = {
    All: 'ALL',
    Some: 'SOME'
};
function instanceOfSpecialtyNotificationScope(value) {
    for (const key in exports.SpecialtyNotificationScope) {
        if (Object.prototype.hasOwnProperty.call(exports.SpecialtyNotificationScope, key)) {
            if (exports.SpecialtyNotificationScope[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function SpecialtyNotificationScopeFromJSON(json) {
    return SpecialtyNotificationScopeFromJSONTyped(json, false);
}
function SpecialtyNotificationScopeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function SpecialtyNotificationScopeToJSON(value) {
    return value;
}
function SpecialtyNotificationScopeToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=SpecialtyNotificationScope.js.map